import SignatureCanvas from "react-signature-canvas";
import styles from "./Agreement.module.scss";

interface Props {
  signRef: React.RefObject<SignatureCanvas | null>;
  termsAndConditions: string;
}

function Agreement(props: Props) {
  const { signRef, termsAndConditions } = props;

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <p className={styles.label}>Booking Agreement</p>
      </div>
      <div className={styles.modalBodyWrapper}>
        <div
          className={styles.termContainer}
          dangerouslySetInnerHTML={{
            __html: termsAndConditions,
          }}
        ></div>
        <div className={styles.signatureContainer}>
          <p className={styles.label}>Sign the agreement</p>
          <div className={styles.signature}>
            <SignatureCanvas
              penColor="black"
              ref={signRef}
              clearOnResize={false}
              backgroundColor="white"
              canvasProps={{
                className: `${styles.canvas}`,
              }}
            />
          </div>
          <div className={styles.buttonContainer}>
            <button
              className={styles.clearButton}
              onClick={() => {
                if (signRef.current) {
                  signRef.current.clear();
                }
              }}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Agreement;
